import { fetcher } from "src/api/fetcher";
import { object, string, type InferInput } from "valibot";

export async function createInitializeAuth({
  emailAddress,
}: {
  emailAddress: string;
}) {
  return await fetcher("/api/1.6/auth/initialize", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      emailAddress,
    }),
    schema: InitializeAuthResponse,
  });
}

const InitializeAuthResponse = object({
  browserId: string(),
});
type InitializeAuthResponse = InferInput<typeof InitializeAuthResponse>;
